<header class="page-header page-header--column">
  <h4 id="txt_unauthorized" class="typo-display-small">
    {{ 'unauthorized.title' | translate }}
  </h4>
  <p>
    {{ 'unauthorized.message' | translate }}
  </p>
</header>